import tagManager from "servicestack/tags/tag-manager";
import tagsFieldset from "servicestack/tags/tags-fieldset";
// import applyTagsFieldset from "servicestack/tags/apply-tags-fieldset";
import tagsViewer from "servicestack/tags/tags-viewer";
import tagsCard from "servicestack/tags/tags-card";
import tagsBadges from "servicestack/tags/tags-badges";

export default app =>
  app
    .component("tagsCard", tagsCard)
    .component("tagsViewer", tagsViewer)
    // .component("applyTagsFieldset", applyTagsFieldset)
    .component("tagsFieldset", tagsFieldset)
    .component("tagsBadges", tagsBadges)
    .component("tagManager", tagManager);
